// Calculator-owned theming. Independent of the widget's src/theme.
// The calculator is dark-only, so there is no light/dark switching — only
// direct CSS-variable overrides from URL params, mapped to --calc-* tokens
// (camelCase → kebab-case), e.g. ?card=1a1a1a → --calc-card: #1a1a1a.

function toCssVar(param: string): string {
  return '--calc-' + param.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
}

export function applyTheme(params: URLSearchParams) {
  const root = document.documentElement;
  for (const [param, value] of params) {
    const colorValue =
      value.startsWith('#') || value.startsWith('rgba') ? value : `#${value}`;
    root.style.setProperty(toCssVar(param), colorValue);
  }
}
